import { routes } from './routes';
export var navBarRoutes = [
    {
        key: 1,
        path: routes.goToAgencies,
        icon: 'ag-agency',
        label: 'Agencies',
        disabled: false,
        matches: [routes.agencies],
        isCustomRoute: false,
        subRoutes: [],
    },
    {
        key: 2,
        path: routes.goToCommissions,
        icon: 'ag-commission',
        label: 'Commission',
        disabled: false,
        matches: [routes.commissions],
        isCustomRoute: false,
        subRoutes: [],
    },
    {
        key: 3,
        path: routes.goToServiceFee,
        icon: 'ag-payment',
        label: 'Service Fee',
        disabled: false,
        matches: [routes.serviceFee],
        isCustomRoute: false,
        subRoutes: [],
    },
];
